import { Box, Typography, Card, CardContent, Alert } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { activityCenterActions } from '../../../../store/slices/activityCenterSlice';
import { TASK_STATUS } from '../../../../constants/activityCenter';
import {
  TaskCompletionActions,
  TaskHeader,
  TaskProgress,
  TaskTimestamp,
  TaskPayload,
} from './components';

const TaskItem = ({ task }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleClearTask = () => {
    dispatch(activityCenterActions.clearTask(task.id));
  };

  return (
    <Card sx={{ mb: 1, border: 1, borderColor: 'divider' }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <TaskHeader title={task.title} status={task.status} onClear={handleClearTask} />
        {task.description && (
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            {task.description}
          </Typography>
        )}
        {task.status === TASK_STATUS.COMPLETED && task.result && (
          <Box sx={{ mb: 1 }}>
            <TaskCompletionActions task={task} />
          </Box>
        )}
        {task.status === TASK_STATUS.FAILED && task.error && (
          <Alert severity="error" sx={{ mb: 1 }}>
            <Typography variant="caption">
              {t(task.error)}
            </Typography>
          </Alert>
        )}
        {task.status === TASK_STATUS.IN_PROGRESS && task.progress !== undefined && (
          <TaskProgress progress={task.progress} />
        )}
        <TaskTimestamp createdAt={task.createdAt} />
        <TaskPayload payload={task.payload} />
      </CardContent>
    </Card>
  );
};

export default TaskItem;
